import React from "react";
import styled from "styled-components";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import LRCard from "./LRCard";

function ChangeHeader(name) {
  let header = "";
  switch (name) {
    case "Assingn_Pickup":
      header = "Shipment Booked";
      break;
    case "Pickup_Assigned":
      header = "Pickup Assigned";
      break;
    case "Pickup_Done":
      header = "Pickup Done";
      break;
    case "Reached_at_CC":
      header = "Reached at CC";
      break;
    case "Connection_Booked":
      header = "Connection Booked";
      break;
    case "Connection_Successfull":
      header = "Connection Successful";
      break;
    case "Received_At_Destination":
      header = "Received at Destination";
      break;
    case "Delivery_Assigned":
      header = "Delivery Assigned";
      break;
    case "Delivery_Confirmation":
      header = "Delivery Confirmation";
      break;
    default:
      header = "Header";
  }
  return header;
}

const LMSProcessColumn = ({ columnHeader, formdata, selectMultiIds, MultiDragableIds, disableLRArr }) => {
  // console.log(columnHeader, formdata, "formdata");
  return (
    <Container className="column">
      <TaskList className="task-list-container">
        <Droppable droppableId={columnHeader} type="task">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                background: snapshot.isDraggingOver ? "lightblue" : "inherit",
                // padding: 3,
                minHeight: "80vh",
              }}
            >
              <div style={{ textAlign: "center", paddingBottom: "10px", fontWeight: "bold" }}>
                {ChangeHeader(columnHeader)} ({formdata[columnHeader]?.length})
              </div>
              {formdata[columnHeader]?.map((e, index) => (
                <LRCard
                  key={index}
                  LRData={e}
                  index={index}
                  columnHeader={columnHeader}
                  selectMultiIds={selectMultiIds}
                  MultiDragableIds={MultiDragableIds}
                  disableLRArr={disableLRArr}
                />
              ))}
              {/* {provided.placeholder} */}
            </div>
          )}
        </Droppable>
      </TaskList>
    </Container>
  );
};

export default LMSProcessColumn;

const Container = styled.div`
  background-color: #ebecf0;
  border-radius: 2px;
  width: 360px;
  height: "80vh";
  /* margin-right: 20px; */
  display: flex;
  flex-direction: column;
`;

const TaskList = styled.div`
  /* padding: 8px; */
  // Adjust this height based on your design needs
  overflow-y: auto;
  /* margin-left: 3px; */
  margin: 5px;
  // Hide scrollbar for Chrome, Safari and Opera
  &::-webkit-scrollbar {
    display: none;
  }

  // Hide scrollbar for IE, Edge and Firefox
  -ms-overflow-style: none; // IE and Edge
  scrollbar-width: none; // Firefox
`;
